module.exports = __webpack_public_path__ + "img/info-grey-18dp.03b6c3e9.svg";